// ABOUTME: What every "share as image" card has in common: the brand palette, the background presets and the export formats.
// ABOUTME: The statistics share modal renders its card over these choices (a workout shares through share-editor).

export const SHARE_LOGO = "/logo-te.webp"

export const SHARE_BRAND = {
  orange: "#fd7134",
  black: "#000000",
  white: "#ffffff",
  teRed: "#e31e24",
}

export interface ShareBackground {
  key: string
  bg: string
  text: string
  accent: string
  overlay?: string
}

export const DEFAULT_SHARE_BACKGROUND: ShareBackground = {
  key: "dark",
  bg: "#0a0a0a",
  text: "#ffffff",
  accent: SHARE_BRAND.orange,
}

export const SHARE_BACKGROUNDS: ShareBackground[] = [
  DEFAULT_SHARE_BACKGROUND,
  { key: "orange", bg: SHARE_BRAND.orange, text: "#ffffff", accent: "#ffffff" },
  {
    key: "photo",
    bg: "url(/bg-photo2.webp)",
    text: "#ffffff",
    accent: SHARE_BRAND.orange,
    overlay: "rgba(0,0,0,0.35)",
  },
  { key: "te", bg: SHARE_BRAND.black, text: "#ffffff", accent: SHARE_BRAND.teRed },
]

export const SHARE_FORMAT_KEYS = ["square", "story", "wide"] as const
export type ShareFormatKey = (typeof SHARE_FORMAT_KEYS)[number]

export const SHARE_FORMATS: Record<ShareFormatKey, { width: number; height: number }> = {
  square: { width: 1080, height: 1080 },
  story: { width: 1080, height: 1920 },
  wide: { width: 1200, height: 630 },
}
